import { useDispatch, useSelector } from 'react-redux';
import { Button, FormControl, FormControlLabel, MenuItem, Radio, RadioGroup, Select, TextField, withStyles } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import TableList from '../TableList';
import { scanReject } from '../../../actions/utActions';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from '../../../reducers/uiSlice';

const FixedTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: 300,
        marginBottom: 20,
    },
}))(TextField);

function ParcelReject() {
    const dispatch = useDispatch();
    const {t} = useTranslation('updateToolbox');

    const [orderReject, setOrderReject] = useState('');

    const handleOrderReject = (event) => {
        setOrderReject(event.target.value);
    };
    const handleKeyPress = (event) => {
        if(event.key === 'Enter') {
            handleScanReject();
        }
    }

    function handleScanReject() {
        dispatch(scanReject(orderReject))
        .then(() => {
            setOrderReject('');
            dispatch(showAlertSnackbar({message: t('success_message'), type: 'success'}))
        })
        .catch(() => {
            setOrderReject('');
            dispatch(showAlertSnackbar({message: t('fail_message'), type: 'error'}))
        })
    }

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'baseline'
                }}
            >
                <FixedTextField
                    variant='outlined'
                    placeholder={t('input_parcel_no')}
                    onChange={handleOrderReject}
                    onKeyPress={(e)=>handleKeyPress(e)}
                    value={orderReject}
                />
                <Button
                    variant="contained"
                    color="primary"
                    style={{ marginLeft: 10 }}
                    onClick={handleScanReject}
                    onChange={handleOrderReject}
                    onKeyPress={handleKeyPress}
                >
                    {t('register_reject')}
                </Button>
            </div>
            <div>
                <TableList/>
            </div>
        </>
    );
}

export default ParcelReject;